// eslint-disable-next-line import/prefer-default-export
export const getAccountsState = (state) => state.accounts;
export const getAccountState = (state) => state.account;
